import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { InfoOutline } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { Tooltip } from '@yme/atoms/tooltip';
import { MOUNTING_INFORMATION, MOUNTING_UNIT_CATEGORY_TYPES } from '@yme/common/constants';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { setIsModalShowed } from '@yme/modals/actions';
import { MODALS } from '@yme/modals/constants';
import { getAttribute } from '@yme/selectors/products';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { checkPTWAccessories, getMountingInformationTime } from './helpers';
export const MountingInformationComponent = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isInfiniteDesktopView, isMobileView } = useWindowSize();
    const mountingInformation = useSelector(getAttribute(MOUNTING_INFORMATION));
    const mountingCategories = useSelector(getAttribute(MOUNTING_UNIT_CATEGORY_TYPES));
    const isPTWAccessory = useMemo(() => checkPTWAccessories(mountingCategories ?? []), [mountingCategories]);
    const handleTooltipInfo = useCallback(() => {
        dispatch(setIsModalShowed({
            type: MODALS.INFO_MODAL,
            data: {
                title: t('partsAccessoriesMerch_expectedMountingTime_label'),
                description: t('partsAccessoriesMerch_expectedMountingTimeDisclaimer_label'),
            },
        }));
    }, [dispatch, t]);
    const tooltipComponent = useMemo(() => (React.createElement(SVGIcon, { type: InfoOutline, pathFill: colorCoreBlack900Base, size: ICON_SIZE.xs, onClick: isMobileView ? handleTooltipInfo : undefined })), [handleTooltipInfo, isMobileView]);
    if (!mountingInformation && !isPTWAccessory) {
        return null;
    }
    return (React.createElement(FlexWrapper, { mb: isInfiniteDesktopView ? '32px' : '24px', isFullWidth: true, alignItems: "center", gap: "4px" },
        React.createElement(RegularTextLevel3, { weight: 500 },
            t('partsAccessoriesMerch_expectedMountingTime_label'),
            ': ',
            React.createElement(RegularTextLevel3, { weight: 400, as: "span" }, getMountingInformationTime({
                mountingInformation,
                contactDealerLabel: t('partsAccessoriesMerch_contactDealerForExpectedMountingTime_label'),
            }))),
        Boolean(mountingInformation) && (React.createElement(React.Fragment, null, isMobileView ? (tooltipComponent) : (React.createElement(Tooltip, { title: t('partsAccessoriesMerch_expectedMountingTimeDisclaimer_label') }, tooltipComponent))))));
};
